import { render } from "./NoticeModal.vue?vue&type=template&id=98716c8e&scoped=true&ts=true"
import script from "./NoticeModal.vue?vue&type=script&lang=ts"
export * from "./NoticeModal.vue?vue&type=script&lang=ts"

import "./NoticeModal.vue?vue&type=style&index=0&id=98716c8e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98716c8e"]])

export default __exports__